import { paths } from 'src/routes/paths';
import Iconify from 'src/components/iconify';

// Common navigation items
const commonItems = {
  home: {
    title: 'Home',
    icon: <Iconify icon="eva:home-fill" />,
    path: '/',
  },
  support: {
    title: 'Support',
    icon: <Iconify icon="ic:round-grain" />,
    path: paths.support,
  },
  logHistory: {
    title: 'Log History',
    path: paths.loghistory,
    icon: <Iconify icon="fluent:timeline-24-regular" />,
  },
  dataSets: {
    title: 'Data Sets',
    path: paths.datasets,
    icon: <Iconify icon="fluent:data-pie-20-filled" />,
  },
};

// Admin-specific items
const adminItems = {
  users: {
    title: 'Users',
    path: paths.users,
    icon: <Iconify icon="fluent:person-24-filled" />,
  }
};

// NWR-specific items
const nwrItems = {
  dashboard: {
    title: 'Dashboard',
    path: paths.nwrDashboard,
    icon: <Iconify icon="fluent:timeline-24-regular" />,
  },
};

// Navigation configurations
export const navConfigUnAuthed = [
  commonItems.home,
  commonItems.support,
];

export const navConfigNewUser = [
  commonItems.home,
  commonItems.support,
];

export const navConfigAuthedAdminApprover = [
  adminItems.users,
  commonItems.logHistory,
  commonItems.dataSets,
  commonItems.support,
];

export const navConfigAuthed = [
  commonItems.dataSets,
  commonItems.support,
];

export const nwrConfigAuthed = [
  commonItems.home,
  nwrItems.dashboard,
  commonItems.support,
];
